import axios from "axios";
import BASE_URL from "../_helpers/constants";

// function for setting the data for onboarding questions
export const setDataForStates = (question, detail, value) => {
  if (!detail?.selectedOptions?.length) {
    return { selectedData: [], remainingData: question.options };
  }

  const selectedData = detail.selectedOptions.map((data) => data.name);

  if (!value) {
    const remainingData = question.options.filter(
      (option) => !selectedData.includes(option)
    );
    return { selectedData, remainingData };
  }

  const remainingData = question.options.filter(
    (option) => !detail.selectedOptions.some((selected) => selected.name === option)
  );

  return { selectedData: detail.selectedOptions, remainingData };
};


// Backend DO-027 (Astra-Backend#344): the WAF on dev/test 403s any query
// string carrying a JSON object with a recognizable key ("where", "include"),
// which is exactly the `?filter={"where":…}` envelope this endpoint used to
// require — onboarding q1-q7, the questionnaire detail screen and the
// dashboard prefill were all dead there. The backend now also accepts flat
// scalar params (clientId, questionId, from), which win over the legacy
// envelope; sending only the flat form avoids the WAF trigger entirely.
export const getOnboardingDetails = async (questionId, clientId, from) => {
  try {
    const clientUserId = clientId || JSON.parse(window.localStorage.getItem("currentUser"))?.user?._id;
    const params = { clientId: clientUserId };
    if (questionId) params.questionId = questionId;
    if (from) params.from = from;
    let res = await axios.get(
      `${BASE_URL}/onboarding/get-user-onboarding`,
      {
        params,
        headers: {
          Authorization: `Bearer ${JSON.parse(window.localStorage.getItem("currentUser")).token
            }`,
        },
      }
    );
    return res;
  } catch (error) {
    return error;
  }
};

//get old onboarding data
export const getOldOnboardingData = async (clientId) => {
  try {
    let res = await axios.get(`${BASE_URL}/onboarding/investment-summaries/${clientId}`, {
      headers: {
        Authorization: `Bearer ${JSON.parse(window.localStorage.getItem("currentUser")).token
          }`,
      },
    });
    return res;
  } catch (error) {
    return error;
  }
};

// Add documentS
// `uploadedFrom` is optional; when provided (e.g. "chat") it will be sent as a form field.
export const uploadDocument = async (files, uploadedFrom = "") => {
  const token = JSON.parse(window.localStorage.getItem("currentUser")).token;
  try {
    // If this is a FormData instance and a source is provided, append it
    if (uploadedFrom && files instanceof FormData) {
      files.append("uploaded_from", uploadedFrom);
    }

    let res = await axios.post(`${BASE_URL}/documents/upload`, files,
      { headers: { "Authorization": `Bearer ${token}`, "Content-Type": "multipart/form-data" } }
    );
    return res;
  } catch (error) {
    return error;
  }
};

//add profile image
export const addProfileImage = async (file) => {
  try {
    let res = await axios.post(
      `${BASE_URL}/containers/client/upload`,
      { file },
      {
        headers: {
          Authorization: `Bearer ${JSON.parse(window.localStorage.getItem("currentUser")).token
            }`,
          "Content-Type": "multipart/form-data",
        },
      }
    );
    return res;
  } catch (error) {
    return error;
  }
};

//get plans
export const getPlan = async (type) => {
  try {
    let res = await axios.get(`${BASE_URL}/subscription/get-price?interval=${type}`, {
      headers: {
        Authorization: `Bearer ${JSON.parse(window.localStorage.getItem("currentUser")).token
          }`,
      },
    });
    return res;
  } catch (error) {
    return error;
  }
};

//get all plans admin
export const getAllPlansAdmin = async () => {
  try {
    let res = await axios.get(`${BASE_URL}/subscription/get-all-price-admin`, {
      headers: {
        Authorization: `Bearer ${JSON.parse(window.localStorage.getItem("currentUser")).token
          }`,
      },
    });
    return res;
  } catch (error) {
    return error;
  }
};

//get single plan
export const getSinglePlansAdmin = async (id) => {
  try {
    let res = await axios.get(`${BASE_URL}/subscription/get-price/${id}`, {
      headers: {
        Authorization: `Bearer ${JSON.parse(window.localStorage.getItem("currentUser")).token
          }`,
      },
    });
    return res;
  } catch (error) {
    return error;
  }
};

// add plan admin
export const createPlanAdmin = async (body) => {
  try {
    let res = await axios.post(`${BASE_URL}/subscription/create-price`, body, {
      headers: {
        Authorization: `Bearer ${JSON.parse(window.localStorage.getItem("currentUser")).token
          }`,
      },
    });
    return res;
  } catch (error) {
    return error;
  }
};

// update plan admin
export const updatePlanAdmin = async (body) => {
  try {
    let res = await axios.put(`${BASE_URL}/subscription/update-price`,  body, {
      headers: {
        Authorization: `Bearer ${JSON.parse(window.localStorage.getItem("currentUser")).token
          }`,
      },
    });
    return res;
  } catch (error) {
    return error;
  }
};

// remove package
export const removePackage = async (id, payload = { active: false }) => {
  try {
    const res = await axios.put(
      `${BASE_URL}/subscription/update-price-status/${id}`,
      payload,
      {
        headers: {
          Authorization: `Bearer ${JSON.parse(window.localStorage.getItem("currentUser")).token
            }`,
        },
      }
    );
    return res;
  } catch (error) {
    return error;
  }
};

// Create Stripe Customer

// Stripe Purchase Subscription
export const createStripeCustomer = async (body) => {
  try {
    let res = await axios.post(`${BASE_URL}/create-customer`, body, {
      headers: {
        Authorization: `Bearer ${JSON.parse(window.localStorage.getItem("currentUser")).token
          }`,
      },
    });
    return res;
  } catch (error) {
    return error;
  }
};

// Stripe Add Card
export const attachPaymentMethod = async (body) => {
  try {
    let res = await axios.post(`${BASE_URL}/subscription/attach-payment-method`, body, {
      headers: {
        Authorization: `Bearer ${JSON.parse(window.localStorage.getItem("currentUser")).token
          }`,
      },
    });
    return res;
  } catch (error) {
    return error;
  }
};

//get profile
export const getProfile = async (userId) => {
  try {
    const token = JSON.parse(window.localStorage.getItem("currentUser")).token;
    const res = await axios.get(`${BASE_URL}/users/${userId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    return res;
  } catch (error) {
    return error;
  }
};

// update profile
export const updateProfile = async (userId, updatedProfile) => {
  try {
    const token = JSON.parse(window.localStorage.getItem("currentUser")).token;
    const res = await axios.put(
      `${BASE_URL}/users/update/${userId}`,
      updatedProfile,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      }
    );
    return res;
  } catch (error) {
    return error;
  }
};

//contact us
export const contactUs = async (email, subject, message, userType) => {
  try {
    const token = JSON.parse(window.localStorage.getItem("currentUser")).token;
    const res = await axios.post(
      `${BASE_URL}/contact-us`,
      { email, subject, message, userType },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );
    return res.data;
  } catch (error) {
    return error;
  }
};

//get documents
export const getDocuments = async (clientId = null) => {
  try {
    const token = JSON.parse(window.localStorage.getItem("currentUser")).token;
    const res = await axios.get(
      `${BASE_URL}/documents/${clientId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );
    return res;
  } catch (error) {
    return error;
  }
};

//remove documents
export const removeDocument = async (id) => {
  try {
    const token = JSON.parse(window.localStorage.getItem("currentUser")).token;
    const res = await axios.delete(
      `${BASE_URL}/documents/file/${id}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );
    return res;
  } catch (error) {
    return error;
  }
};

//get slots for appointment booking
export const getSlotsForAppointment = async (body) => {
  try {
    const res = await axios.post(
      `${BASE_URL}/availability/all-slots`,
      body,
      {
        headers: {
          Authorization: `Bearer ${JSON.parse(window.localStorage.getItem("currentUser")).token}`,
          "Content-Type": "application/json",
        },
      }
    );
    return res;
  } catch (error) {
    return error;
  }
};

//get slots for appointment booking
export const bookAppointment = async (body) => {
  try {
    const res = await axios.post(
      `${BASE_URL}/appointments/add-appointment`,
      body,
      {
        headers: {
          Authorization: `Bearer ${JSON.parse(window.localStorage.getItem("currentUser")).token}`,
          "Content-Type": "application/json",
        },
      }
    );
    return res;
  } catch (error) {
    return error;
  }
};

//get appointments old
export const getAllAppointments = async (clientId, advisorId) => {
  const role = JSON.parse(localStorage.getItem("currentUser"))?.user?.role?.name;

  try {
    let filterData;
    if (role === 'client') {
      filterData = JSON.stringify({
        where: { clientId: clientId },
        include: "advisor",
        order: "date ASC"
      });
    } else {
      if (role === 'advisor' && !clientId) {
        filterData = JSON.stringify({
          where: { advisorId: advisorId },
          include: "client",
          order: "date ASC"
        });
      }
      else {
        filterData = JSON.stringify({
          where: { clientId: clientId, appointment_status: 'completed' },
          include: "advisor",
          order: "date ASC",
        });
      }
    }

    const res = await axios.get(
      `${BASE_URL}/appointments?filter=${filterData}`,
      {
        headers: {
          Authorization: `Bearer ${JSON.parse(window.localStorage.getItem("currentUser")).token}`,
          "Content-Type": "application/json",
        },
      }
    );
    return res;
  } catch (error) {
    return error;
  }
};

//get appointments by advisor id
export const getAllAppointmentsByAdvisor = async (advisorId) => {
  try {
    const token = JSON.parse(window.localStorage.getItem("currentUser")).token;
    const res = await axios.get(
      `${BASE_URL}/appointments/appointments-by-advisor/${advisorId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );
    return res;
  } catch (error) {
    return error;
  }
};

//get slots by advisor id
export const getSlotsByParticularAdvisor = async (body) => {
  try {
    const token = JSON.parse(window.localStorage.getItem("currentUser")).token;
    const res = await axios.post(
      `${BASE_URL}/availability/slots`,
      body,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );
    return res;
  } catch (error) {
    return error;
  }
};

// get all users
export const getAllUserList = async (userType) => {
  try {
    const token = JSON.parse(window.localStorage.getItem("currentUser")).token;
    const res = await axios.get(
      `${BASE_URL}/users/get-all-users-by-role/${userType}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );
    return res;
  } catch (error) {
    return error;
  }
};

// get users and appointment by advisor id
export const getUsersListByAdvisorId = async (advisorId) => {
  try {
    const token = JSON.parse(window.localStorage.getItem("currentUser")).token;
    const res = await axios.get(
      `${BASE_URL}/appointments/users-by-advisor/${advisorId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );
    return res;
  } catch (error) {
    return error;
  }
};

// block/unblock advisor client
export const blockUnblockUser = async (body) => {
  try {
    let res = await axios.post(`${BASE_URL}/users/block-unblock`, body, {
      headers: {
        Authorization: `Bearer ${JSON.parse(window.localStorage.getItem("currentUser")).token
          }`,
      },
    });
    return res;
  } catch (error) {
    return error;
  }
};

// Get Notifications
export const getNotifications = async (userId) => {
  try {
    const token = JSON.parse(window.localStorage.getItem("currentUser")).token;
    const res = await axios.get(
      `${BASE_URL}/notification/notification-by-id/${userId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );
    return res;
  } catch (error) {
    return error;
  }
};

// Send custom Notification
export const sendManualNotification = async (body) => {
  try {
    let res = await axios.post(`${BASE_URL}/manual-notification/send-manual-notification`, body, {
      headers: {
        Authorization: `Bearer ${JSON.parse(window.localStorage.getItem("currentUser")).token
          }`,
      },
    });
    return res;
  } catch (error) {
    return error;
  }
};

// Confirm Appointment Reschedule ---------
export const confirmAppointmentRescheduleRequest = async (body) => {
  const token = JSON.parse(window.localStorage.getItem("currentUser")).token;
  try {
    const res = await axios.post(
      `${BASE_URL}/appointments/confirm-reschedule`,
      body,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );
    return res;
  } catch (error) {
    return error;
  }
};

// Deny Appointment Reschedule
export const denyAppointmentRescheduleRequest = async (body) => {
  try {
    const res = await axios.post(
      `${BASE_URL}/appointments/confirm-reschedule`,
      body,
      {
        headers: {
          Authorization: `Bearer ${JSON.parse(window.localStorage.getItem("currentUser")).token}`,
          "Content-Type": "application/json",
        },
      }
    );
    return res;
  } catch (error) {
    return error;
  }
};

// Get Dashboard Data --------------------------
export const getDahboardData = async (body) => {
  try {
    const res = await axios.post(
      `${BASE_URL}/getDashboardData`,
      body,
      {
        headers: {
          Authorization: `Bearer ${JSON.parse(window.localStorage.getItem("currentUser")).token}`,
          "Content-Type": "application/json",
        },
      }
    );
    return res;
  } catch (error) {
    return error;
  }
};


//get advisor Availability
export const getAdvisorAvailability = async (advisorId) => {
  try {
    const token = JSON.parse(window.localStorage.getItem("currentUser")).token;

    const res = await axios.get(
      `${BASE_URL}/availability/get-availabilityById/${advisorId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );
    return res;
  } catch (error) {
    return error;
  }
};

//update advisor timezone
export const updateAdvisorTimezone = async (body) => {
  try {
    const token = JSON.parse(window.localStorage.getItem("currentUser")).token;
    const res = await axios.post(
      `${BASE_URL}/availability/update-availability-timezone`,
      body,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );
    return res;
  } catch (error) {
    return error;
  }
};

//update advisor Availability
export const updateAdvisorAvailability = async (availabilityId, body) => {
  try {
    const token = JSON.parse(window.localStorage.getItem("currentUser")).token;
    const res = await axios.patch(
      `${BASE_URL}/availability/update-availability/${availabilityId}`,
      body,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );
    return res;
  } catch (error) {
    return error;
  }
};



//get off dates
export const getOffDates = async (advisorId) => {
  try {
    const token = JSON.parse(window.localStorage.getItem("currentUser")).token;
    const res = await axios.get(
      `${BASE_URL}/availability/get-offdate/${advisorId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );
    return res;
  } catch (error) {
    return error;
  }
};

//add off dates
export const addOffDate = async (advisorId, date) => {
  try {
    const token = JSON.parse(window.localStorage.getItem("currentUser")).token;
    const res = await axios.post(
      `${BASE_URL}/availability/add-offdate/${advisorId}`,
      { date },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );
    return res;
  } catch (error) {
    return error;
  }
};

//remove off dates
export const removeOffDate = async (offDayId) => {
  const token = JSON.parse(window.localStorage.getItem("currentUser")).token;
  try {
    const res = await axios.delete(
      `${BASE_URL}/availability/delete-offdate/${offDayId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );
    return res;
  } catch (error) {
    console.error("Error removing off date:", error);
    return error.response ? error.response : error;
  }
};

// Request to Reschedule (Advisor to client)
export const sendAppointmentRescheduleRequest = async (body) => {
  try {
    const token = JSON.parse(window.localStorage.getItem("currentUser")).token;
    const res = await axios.post(
      `${BASE_URL}/appointments/request-reschedule`,
      body,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );
    return res;
  } catch (error) {
    return error;
  }
};

//get client appointments by client id
export const getClientAppointments = async (clientId) => {
  try {
    const token = JSON.parse(window.localStorage.getItem("currentUser")).token;
    const res = await axios.get(
      `${BASE_URL}/appointments/appointments-by-client/${clientId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );
    return res;
  } catch (error) {
    return error;
  }
};

//get client past meeting with advisor 
export const getClientAppointmentsByParticularAdvisor = async (body) => {
  try {
    const token = JSON.parse(window.localStorage.getItem("currentUser")).token;
    const res = await axios.post(
      `${BASE_URL}/appointments/appointments-by-advisor`,
      body,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );
    return res;
  } catch (error) {
    return error;
  }
};
//get client past meeting with admin 
export const getCompletedAppointmentsByClientId = async (clientId) => {
  try {
    const token = JSON.parse(window.localStorage.getItem("currentUser")).token;
    const res = await axios.get(
      `${BASE_URL}/appointments/passed-appointments-by-client/${clientId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );
    return res;
  } catch (error) {
    return error;
  }
};

// Get appointment details -------------
//
// DO-027 (backend WAF): `GET /appointments/:id` (controllers/appointmentController.js
// getAppointmentById) reads only req.params.id — it has never read req.query
// at all, so the `?filter={"where":{"timezone":…}}` this sent was always
// dead weight server-side. It's also exactly the JSON-in-query-string shape
// the dev/test WAF 403s on, so on those environments this call failed before
// the request even reached Express. Dropping it changes nothing the backend
// ever used and removes the WAF trigger.
export const getAppointmentDetails = async (id, userTimezone) => {
  try {
    const res = await axios.get(
      `${BASE_URL}/appointments/${id}`,
      {
        headers: {
          Authorization: `Bearer ${JSON.parse(window.localStorage.getItem("currentUser")).token}`,
          "Content-Type": "application/json",
        },
      }
    );
    return res;
  } catch (error) {
    return error;
  }
}

// Request to start cloud recording
export const startCloudRecordingRequest = async (body) => {
  try {
    const res = await axios.post(
      `${BASE_URL}/start-cloud-recording`,
      body,
      {
        headers: {
          Authorization: `Bearer ${JSON.parse(window.localStorage.getItem("currentUser")).token}`,
          "Content-Type": "application/json",
        },
      }
    );
    return res;
  } catch (error) {
    return error;
  }
};

// Request to fetch live zoom sessions
export const fetchLiveZoomSessionsRequest = async (body) => {
  try {
    const res = await axios.post(
      `${BASE_URL}/fetch-live-zoom-sessions`,
      body,
      {
        headers: {
          Authorization: `Bearer ${JSON.parse(window.localStorage.getItem("currentUser")).token}`,
          "Content-Type": "application/json",
        },
      }
    ).then(res => res.data);
    return res;
  } catch (error) {
    return error;
  }
};

//rate advisor meeting
export const rateMeeting = async (body) => {
  try {
    const token = JSON.parse(window.localStorage.getItem("currentUser")).token;
    const res = await axios.post(
      `${BASE_URL}/rate-advisor`,
      body,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );
    return res;
  } catch (error) {
    return error;
  }
};

//get advisor average rating
export const getAdvisorAverageRating = async (advisorId) => {
  try {
    const token = JSON.parse(window.localStorage.getItem("currentUser")).token;
    const res = await axios.get(
      `${BASE_URL}/ratingByAdvisorId/${advisorId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );
    return res;
  } catch (error) {
    return error;
  }
};

// `updateSelectedPlan` used to sit here, posting to `POST /users/update-selected-plan`
// — note the absent `Authorization` header, which was not an oversight in this
// wrapper: the route had no auth middleware either. It wrote `selected_plan`,
// `total_meetings` and `consumed_meetings: 0` on a `userId` read straight from
// the body, so anyone who could reach the API could grant themselves a plan, and
// could repeat the call to reset their used meetings to zero.
//
// Backend SEC-048 removed it rather than gating it (Astra-Backend#52): the
// purchase handler already knows the subscription Stripe just created and the
// plan's meeting allotment, so `updateUserSubscription` writes all of it as part
// of the purchase (`helpers/stripe.helper.js`). The route is a 404 now. The
// screen re-reads the profile instead — see `handleSubscriptionPurchaseFlow`.


export const checkBlockedStatus = async (userId) => {
  try {
    const token = JSON.parse(window.localStorage.getItem("currentUser")).token;
    const res = await axios.get(
      `${BASE_URL}/users/check-status/${userId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );
    return res;
  } catch (error) {
    return error;
  }
}
export const removeNotification = async (notificationId, type, userId) => {
  let body = { notificationId, type, userId }
  try {
    const token = JSON.parse(window.localStorage.getItem("currentUser")).token;
    const res = await axios.delete(
      `${BASE_URL}/notification/notifications`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        data: body,
      }
    );
    return res;
  } catch (error) {
    return error;
  }
}

export const removeProfileImage = async (userId) => {
  try {
    const token = JSON.parse(window.localStorage.getItem("currentUser")).token;
    const res = await axios.patch(
      `${BASE_URL}/users/remove-profile-img`,
      { userId },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );
    return res;
  } catch (error) {
    return error;
  }
}

export const createOneTimeIntent = async (email, duration,priceId) => {
  try {
    const token = JSON.parse(window.localStorage.getItem("currentUser")).token;
    const res = await axios.post(
      `${BASE_URL}/subscription/create-one-time-intent`,
      { email, duration,priceId },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );
    return res;
  } catch (error) {
    return error;
  }
}

// No `amount`. It was the price of the meeting, chosen by the person paying for
// it: `AppointmentBooking.jsx` read the number out of `get-meeting-price` and
// forwarded it here through the router, so an edited value bought an advisor
// meeting for a cent and verifying the payment afterwards confirmed the cent.
// Backend SEC-048 made the server read the same platform singleton itself — 30
// minutes is `oneAdditionalMeetingPrice`, 60 is `twoAdditionalMeetingPrice`,
// exactly the mapping that screen used. The key is still accepted and ignored,
// which is why it has to go from here rather than stay: a number the server
// discards is one this client only looks like it controls. `duration` is what
// picks the price now, and the server also stamps it into the intent's metadata
// so `update-meeting-count` credits the right number of meetings.
export const createPayAsYouGoIntent = async (email, duration) => {
  try {
    const token = JSON.parse(window.localStorage.getItem("currentUser")).token;
    const res = await axios.post(
      `${BASE_URL}/subscription/createPayAsYouGoIntent`,
      { email, duration },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );
    return res;
  } catch (error) {
    return error;
  }
}

export const saveOneTimePayment = async (email, transactionDetails, duration) => {
  try {
    const token = JSON.parse(window.localStorage.getItem("currentUser")).token;
    const res = await axios.post(
      `${BASE_URL}/subscription/save-one-time-payment`,
      { email, transactionDetails, duration },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );
    return res;
  } catch (error) {
    return error;
  }
}

export const updateAppointmentStatus = async (id, appointment_status) => {
  try {
    const token = JSON.parse(window.localStorage.getItem("currentUser")).token;
    const res = await axios.put(
      `${BASE_URL}/appointments/update-appointment-status/${id}`,
      { appointment_status },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );
    return res;
  } catch (error) {
    return error;
  }
}

export const getCountryCode = async () => {
  try {
    
    const res = await axios.get(
      `${BASE_URL}/country-codes`,
      {
        headers: {

          "Content-Type": "application/json",
        },
      }
    );
    return res;
  } catch (error) {
    return error;
  }
}

export const getZoomData = async (id) => {
  try {
    const token = JSON.parse(window.localStorage.getItem("currentUser")).token;
    const res = await axios.get(
      `${BASE_URL}/appointments/get-zoom-data/${id}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );
    return res;
  } catch (error) {
    return error;
  }
}

export const getUserGrowthData = async () => {
  try {
    const token = JSON.parse(window.localStorage.getItem("currentUser")).token;
    const res = await axios.get(
      `${BASE_URL}/users/getGrowth`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );
    return res;
  } catch (error) {
    return error;
  }
}

export const markNotificationSeen = async (notificationId) => {
  try {
    const token = JSON.parse(window.localStorage.getItem("currentUser")).token;
    const res = await axios.patch(
      `${BASE_URL}/notification/mark-seen`,
      { notificationId },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );
    return res;
  } catch (error) {
    return error;
  }
}

export const verifyJwtToken = async (jwttoken) => {
  try {
    
    const res = await axios.post(
      `${BASE_URL}/users/verify-jwttoken`,
      { jwttoken },
      {
        headers: {
          Authorization: `Bearer ${jwttoken}`,
          "Content-Type": "application/json",
        },
      }
    );
    return res;
  } catch (error) {
    return error;
  }
}

// Both /addonmeeting routes require a token now (Astra-Backend#274, SEC-116),
// and the write additionally requires super-admin. Neither call sent one.
export const AddOnMeeting = async () => {
  try {
    const token = JSON.parse(window.localStorage.getItem("currentUser"))?.token;
    const res = await axios.get(
      `${BASE_URL}/addonmeeting/get-meeting-price`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );
    return res;
  } catch (error) {
    return error;
  }
}

// Alias: same as getAllUserList (admin list uses this name).
export const getAllAdminList = getAllUserList;

// Alias: same as updateProfile (admin user update naming).
export const updateAdmin = updateProfile;

export const getNotes = async (appointmentId, userType) => {
  try {
    const token = JSON.parse(window.localStorage.getItem("currentUser")).token;
    const res = await axios.get(
      `${BASE_URL}/appointments/get-note/${appointmentId}/${userType}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );
    return res;
  } catch (error) {
    return error;
  }
};

export const saveNotes = async (appointmentId, notes, userType) => {
  try {
    const token = JSON.parse(window.localStorage.getItem("currentUser")).token;
    const res = await axios.post(
      `${BASE_URL}/appointments/add-note/${appointmentId}`,
      { notes, userType },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );
    return res;
  } catch (error) {
    return error;
  }
};

export const getDashboardInsights = async () => {
  try {
    const token = JSON.parse(window.localStorage.getItem("currentUser")).token;
    const res = await axios.get(
      `${BASE_URL}/insights/latest`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );
    return res;
  } catch (error) {
    return error;
  }
};

export const createPlaidLinkToken = async (userId,redirect_uri) => {
  try {
    const token = JSON.parse(window.localStorage.getItem("currentUser"))?.token;
    const response = await axios.post(
      `${BASE_URL}/plaid/create-link-token`,
      { userId,redirect_uri },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );
    return response.data.link_token;
  } catch (error) {
    console.error("Error creating Plaid link token:", error?.response?.status);
    throw error;
  }
};

export const exchangePlaidPublicToken = async (public_token, userId) => {
  try {
    const token = JSON.parse(window.localStorage.getItem("currentUser"))?.token;
    await axios.post(
      `${BASE_URL}/plaid/exchange-token`,
      { public_token, userId },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );
  } catch (error) {
    console.error("Error exchanging Plaid token:", error?.response?.status);
    throw error;
  }
};


export const getPlaidTransactions = async () => {
  try {
    const token = JSON.parse(window.localStorage.getItem("currentUser"))?.token;
    const response = await axios.get(
      `${BASE_URL}/plaid/transactions`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );
    return response?.data;
  } catch (error) {
    // SP6: after the last unlink the server answers 404 "No banks connected"
    // — no transactions, not an error (Rajiv 11).
    if (error?.response?.status === 404) return [];
    console.error("Error geting transactions:", error);
    throw error;
  }
};

export const getFinancialGoals = async () => {
  try {
    const token = JSON.parse(window.localStorage.getItem("currentUser"))?.token;
    const response = await axios.get(
      `${BASE_URL}/insights/financial-goal`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );
    return response?.data;
  } catch (error) {
    console.error("Error getting financial goals:", error);
    throw error;
  }
};


export const incrementTotalMeetings = async (userId) => {
  try {
    const token = JSON.parse(window.localStorage.getItem("currentUser"))?.token;
    const response = await axios.post(
      `${BASE_URL}/subscription/increment-total-meetings/${userId}`,
      {},
      {
        headers: {
          authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );
    return response?.data;
  } catch (error) {
    console.error("Error getting financial goals:", error);
    throw error;
  }
};